<template>
    <div id="payments-info">
        <!--=====================================-->
        <!--=        Payments Area Start     =-->
        <!--=====================================-->
        <section class="section section-padding">
            <div class="container">
                <div class="row">
                    <div class=" col-lg-8">
                        <div class="section-heading heading-left">
                            <span class="subtitle primary">Pagos frecuentes.</span>
                            <div class="row">
                                <div class="col-lg-12">
                                    <h2 class="font-weight-100">
                                        El mes pasado distribuimos <span class="bold">{{ isMounted ? explicitMoneyFormat(rgStats.applicant_payments_to_investors || 0, 0) : '--' }}</span>
                                        a <span class="bold">{{ isMounted ? generalNumberFormat((rgStats.investor_received_collection || 0), 0) : '--' }}</span> inversionistas.
                                    </h2>
                                    <p class="black h1 w-75">Históricamente hemos distribuido {{ isMounted ? explicitMoneyFormat(rgStats.amount_paid_to_investors || 0, 0) : '--' }}. 
                                        <router-link :to="{ name: 'yieldPage' }" class="rg-a">Conoce más</router-link>.
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-4">
                        <div class="widget widget-recent-post">
                            <div class="post-list-wrap">
                                <div v-for="(item, index) in getPayments" :key="index" class="single-post">
                                    <div class="post-thumbnail thumbnail-img">
                                        <img :src="getCover(item.category)" alt="Blog">
                                    </div>
                                    <div class="post-content">
                                        <h6 class="title">{{ item.alias }} realizó <br> su pago {{ item.payment }}  {{ daysAgo(item.date) }}.</h6>
                                        <ul class="blog-meta list-unstyled">
                                            <li>{{ intDigitsFormat(item.investors) }} inversionistas fueron beneficiados.</li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <!-- card -->
                        <ButtonCard :rgStats="rgStats" :isMounted="isMounted"></ButtonCard>
                    </div>
                </div>
            </div>
        </section>
    </div>
</template>

<script>
import ButtonCard from './partials/button-card.vue';
import formatHelpers from "@mixins/formatHelper.js";
import dateHelper from "@mixins/dateHelper.js";
export default {
    name: "PaymentsInfo",
    props: ["rgStats", "isMounted"],
    mixins: [formatHelpers, dateHelper],
    components: {
        ButtonCard
    },
    data() {
        return {
            img_dummy: "https://api.redgirasol.com/storagev3/documents/view_document_file/10092/project/1333?access_token=eyJ0eXAiOiJKV1QiLCJhbGciOiJSUzI1NiJ9.eyJhdWQiOiI5IiwianRpIjoiYWU2ODM2NDViYjU4MmI3MTQ1MmU3YWJmZTQyZGFkYzcwOTc2MzlhYWU5MzdiMmExNjRlMDY5OWNkYWUyZDMyODdlMDE2NGY4ZDE1MjQ4MGYiLCJpYXQiOjE2ODIzNTA3NTkuMzc0MTcsIm5iZiI6MTY4MjM1MDc1OS4zNzQxNzIsImV4cCI6MTcxMzk3MzE1OS4zNzA4MjYsInN1YiI6IjEiLCJzY29wZXMiOlsiZ2V0LW5ld3MiLCJnZXQtc3RhdGVzIiwicHJvamVjdC1wdWJsaXNoZWQiXX0.ikyoZguTIzcvSubP5zdVqnIBP3-aUp5lJsVP8Ru3tqP6ujvhG7g23gQ5UV1lCoB2oWcBdaxhwgxw8mlGukIM6dE8e4n07CRH_NkBHOs4xPLxtMTm1i8u1wWxrnQFssnaEiTACl-Sqgq1d1xhdQ1xOEtnLrb5C3TApvRwq8DXc13Ly3PBMP9wzqq7TQDznfLFl7oI_ADuIMD5PbHWTRLkBuIVviGnj5TElyeWTLqqAq30Zudp2F06KEFmyuhgUkHQ_zqDwmh2StgjCiwaAMw03cDe-rAuacOsy5mbSKuJDOG41DjxcDILugCGX-kQA_yFdzNaxttP6NLwDPsm6yQInp6ofnMSVaHxesvEiZrwNVccpy9JhZRznBp-ZZ79YF_1V_WIHKKjr0Y4tgQe96p89MYdj_FetHoCfQc63tJnqmrc1fiCvy3q_rk3VM5onH4L6q8k0EQGf4Edk03E7c0WQsyFd0yjdf-JS7oTN8NY-Ty4Lv27hvqUKcLeDisBqOtpad1zacjIFcy12opymCHmGKEPtuV4kQVqxf_GSmroM2LgKtjS4rT5lZDPigV3BLnUlEiMr1KiykjKB2b2rugAwWAqSBjb2Sdd5UZuV7jENC9Qn3kBI766-WR7meIVXlJpBXEGTnaW3jv_c97Jp1RZJCf9pU_02gP5pm2pY9TPo_E"
            , img_base: "https://cdn.redgirasol.com/nuevo_portal/banners/banner-"
            , coverBase: "https://cdn.redgirasol.com/green/PORTADAS_PROYECTOS/"
        }
    },
    computed: {
        getPayments() {
            if(this.isMounted) {
                return JSON.parse(this.rgStats.applicant_payments_collection);
            } else {
                return [];
            }
        }
    },
    methods: {
        calculateImgType (projectType) {
            const iconTypes = {
                "sfv": "rayo"
            };

            return this.img_base + (iconTypes[projectType] || "rayo") + ".png";
        },
        getCover(category){
            if(category) {
                const ods = JSON.parse(category.ods);
                let cover = "";
                if(ods) {
                    cover = ods.cover || "--";
                } else {
                    cover = "PORTADAS-09.png";
                }
                return `${this.img_base}${cover}` || "--";
            } else {
                return `${this.img_base}PORTADAS-09.png` || "--";
            }
        }
    }
}

</script>

<style scoped>

.p-width {
    width: 50rem !important;
}

.thumbnail-img {
    width: 25% !important;
}

.post-list-wrap {
    max-height: 22rem;
    overflow-y: auto;
    overflow-x: hidden;
}

.post-list-wrap::-webkit-scrollbar {
    width: 0;
}
</style>